// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    // Load product html from liquid
    //loadProductFromLiquid: true,
    //loadProductFromLiquidType: 'ajax',
    paginationTypeAdvanced: false,
    showLoadMoreLoading: true,
    showLoading: true,
    positionShowInfiniteLoading: 700,
    enableKeepScrollbackPosition: false,
    filterTreeMobileStyle: 'style1'
    //urlScheme: 0
  },
};

// Declare Templates
var boostPFSTemplate = {
    'productGridItemHtml': '<div class="boost-pfs-filter-product-item col-6 col-md-3 tt-col-item"></div>',
	// Pagination Template
	'previousHtml': '',
	'nextHtml': '<a href="{{itemUrl}}" class="btn-pagination btn-next"></a>',
	'pageItemHtml': '<li><a href="{{itemUrl}}" data="XXX">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li class="active"><a href="#">{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li>{{itemTitle}}</li>',
	'paginateHtml': '{{previous}}<ul>{{pageItems}}</ul>{{next}}',

	// Sorting Template
	'sortingHtml': '{{sortingItems}}',
  	'showLimitHtml': '{{showLimitItems}}'
};


(function () {
	BoostPFS.inject(this);

    function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
  
  	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		return itemHtml;
	};
	
  	/************************** BUILD TOOLBAR **************************/
		// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (Settings.getSettingValue('general.paginationType') == 'default' && totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage -1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};
	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var selected = '';
					if (paramSort == k) {
						selected = 'selected';
					}
					sortingItemsHtml += '<option value="' + k + '"' + selected + '>' + sortingArr[k] + '</option>';
				}
            	html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
      	
		return html;
	};

    
    ProductSorting.prototype.render = function() {
      jQ(Selector.topSorting).html(this.compileTemplate());
      var $selectInput = jQ(Selector.topSorting);
      if ($selectInput.length) {
        $selectInput.val(Globals.queryParams.sort);
      }
    }
    
	ProductSorting.prototype.bindEvents = function() {
	    jQ(Selector.topSorting).change(function(event) {
          
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		})
	};    
	
	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k = 0; k < arr.length; k++) {
					showLimitItemsHtml += '<option value="' + arr[k] + '">' + arr[k] + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};

    ProductLimit.prototype.render = function() {
      jQ(Selector.topShowLimit).html(this.compileTemplate());
      var $topLimitSelect = jQ(Selector.topShowLimit);
      if ($topLimitSelect.length) {
        $topLimitSelect.val(Globals.queryParams.limit);
      }
    }

  	
  
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};

	/************************** END BUILD TOOLBAR **************************/
	

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		initImagesSizeResize()
        
        
        // Show/Hide Pagination msg
        var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(this.totalProduct  / Globals.queryParams.limit);

        if (currentPage == totalPage) setTimeout(function () { jQ('.tt_item_all_js').show(); }, 1000);
        else jQ('.tt_item_all_js').hide();
      
        if (currentPage <= totalPage) setTimeout(function () { jQ('.boost-pfs-filter-load-more-loading').hide(); }, 10000);
        else jQ('.boost-pfs-filter-load-more-loading').show();

        for (let i = 0; i < data.length; i++) {
          let requestReg = formRequest(data[i].handle);
          requestReg.then((res_success) => {
            let res = JSON.parse(res_success);
            if(jQ('.boost-pfs-filter-product-item[data-id="'+ res.id +'"]').length > 0){
              jQ('.boost-pfs-filter-product-item[data-id="'+ res.id +'"]').html(res.html);
            }
          }).catch((res_error) => {
            console.log(res_error)
          });
        }
	};

	// Build additional elements
	Filter.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html('('+data.total_product+')');
      
	};
  
    ProductPagination.prototype.showLoading = function(){
    //if (this.settings.showLoadMoreLoading && this.settings.showLoading === false || (this.settings.showLoadMoreLoading && this.paginationType == "infinite" && this.settings.showLoading) ){
      this.$loadMore.find(Selector.loadMoreLoading).show();
    //}
  }

  function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open("GET", Shopify.routes.root + 'products/'+ value +'?view=boost-pfs-product-item');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => resolve(xhr.responseText);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
    });
  }
    
})();